import type {MergeSuggestion} from 'services/mergeSuggestions/types';
import type {CollectionWithoutLinks} from 'services/series/types';

const mapCollectionName = (collection?: CollectionWithoutLinks): string => {
  return collection?.titles?.[0]?.value ?? '';
};

export const applyCollectionTitlesToMergeSuggestions = (
  data: MergeSuggestion[],
  collections: CollectionWithoutLinks[],
): MergeSuggestion[] => {
  if (collections.length === 0) {
    return data;
  }

  return (data ?? []).map(d => ({
    ...d,
    sourceName: mapCollectionName(collections.find(s => s.id === d.sourceId)),
    targetName: mapCollectionName(collections.find(s => s.id === d.targetId)),
  }));
};
